var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideosHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2",
    "data-name": "Groupe 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.398,
    height: 28,
    viewBox: "0 0 24.398 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M11.33,25.251a.354.354,0,0,1-.165-.044A.331.331,0,0,1,11,24.92V19.331a.331.331,0,0,1,.5-.287l4.845,2.794a.331.331,0,0,1,0,.573L11.5,25.205A.3.3,0,0,1,11.33,25.251Zm.331-.9,3.853-2.221-3.853-2.221Z",
    fill: "#35ce92",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M4.725,26.9a.553.553,0,1,0,.389.162A.551.551,0,0,0,4.725,26.9Z",
    fill: "#35ce92",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M4.725,27.78a.331.331,0,1,0-.331-.331A.331.331,0,0,0,4.725,27.78Z",
    fill: "#35ce92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M14.929,27.78a.331.331,0,0,1,0-.661h6.625a2.19,2.19,0,0,0,2.188-2.188V17.213H1.712v7.722A2.19,2.19,0,0,0,3.9,27.123h6.625a.331.331,0,0,1,0,.661H3.895A2.857,2.857,0,0,1,1.049,24.93V11.768L.112,8.549a2.853,2.853,0,0,1,1.94-3.528L19.018.11A2.958,2.958,0,0,1,19.808,0a2.864,2.864,0,0,1,2.741,2.056l.943,3.263a.339.339,0,0,1-.028.254.356.356,0,0,1-.2.16L5.2,10.963l-1.565.43H24.067a.332.332,0,0,1,.331.331V24.935a2.853,2.853,0,0,1-2.85,2.85h-6.62Zm3.357-11.228h5.451v-4.5H20.882Zm-4.321,0h3.555l2.6-4.5H16.56Zm-4.316,0H13.2l2.6-4.5H12.248Zm-4.321,0H8.884l2.6-4.5H7.924Zm-3.616,0H4.568l2.6-4.5H1.712ZM2.242,5.661A2.192,2.192,0,0,0,.749,8.367L1.6,11.31,7.049,9.734,2.849,5.7A.358.358,0,0,1,2.8,5.65l-.088-.132Zm1.169-.336L7.6,9.354a.356.356,0,0,1,.044.05l.088.132,3.456-1L7,4.5a.358.358,0,0,1-.044-.05l-.088-.132Zm4.15-1.2,4.194,4.029a.352.352,0,0,1,.044.05l.088.132,3.456-1L11.149,3.3a.358.358,0,0,1-.044-.05l-.088-.132Zm4.145-1.207L15.9,6.947a.351.351,0,0,1,.044.05l.088.132,3.456-1L15.292,2.094a.358.358,0,0,1-.044-.05l-.088-.132Zm8.1-2.254a2.007,2.007,0,0,0-.6.088l-3.346.97,4.194,4.029a.351.351,0,0,1,.044.05l.088.132,2.574-.75L21.906,2.24a2.2,2.2,0,0,0-2.1-1.579Z",
    fill: "#35ce92",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosHover);
export default __webpack_public_path__ + "static/media/videos-hover.5d2c21e6ddb3b59e9e3d05455ce9dfa0.svg";
export { ForwardRef as ReactComponent };